export default __webpack_public_path__ + "static/media/DINAMITA.4cb8eb08.jpeg";